import { Web3Storage } from "web3.storage";
import * as Client from '@web3-storage/w3up-client'
import { StoreMemory } from '@web3-storage/w3up-client/stores/memory'
import { importDAG } from '@ucanto/core/delegation'
import { CarReader } from '@ipld/car'
import * as Signer from '@ucanto/principal/ed25519'
import { Buffer } from 'buffer';

const web3storage_key = "z6MkkqyxuWvBpyNXpqrARUpKPiZBcPdQ7q5Y2JWseNLQhmjG";
const PROOF = `EaJlcm9vdHOAZ3ZlcnNpb24BrAIBcRIgmgxiS5+e3jC8inT7AjtzCDzXlzsZJeqCD3n5nSEnCrKo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`

export const IPFS_GATEWAY = ".ipfs.w3s.link";

function GetAccessToken() {
  return web3storage_key;
}

function MakeStorageClient() {
  return new Web3Storage({ token: GetAccessToken() });
}

export const ipfsSaveContent = async (files) => {
  console.log("Uploading files to IPFS with web3.storage....");
  // const client = await Client.create()
  // await client.login('28721054@qq.com')
  // await client.setCurrentSpace('did:key:z6MkoUrJKHeB4461A1JoiMBAHB4wWGot1HDPHuQ8p31tRQf7')

  console.log(process.env.REACT_APP_KEY)
  const principal = Signer.parse(process.env.REACT_APP_KEY)
  const store = new StoreMemory()
  const client = await Client.create({ principal, store })
  console.log(process.env.REACT_APP_PROOF);
  const proof = await parseProof(PROOF)
  console.log("got proof")
  const space = await client.addSpace(proof)
  await client.setCurrentSpace(space.did())
  console.log(files)
  const cid = await client.uploadFile(files)
  console.log("Stored files with cid:", cid);
  return cid;
};


async function parseProof (data) {
  const blocks = []
  const reader = await CarReader.fromBytes(Buffer.from(data, 'base64'))
  for await (const block of reader.blocks()) {
    blocks.push(block)
  }
  return importDAG(blocks)
}
